// extracted by mini-css-extract-plugin
module.exports = {"root":"ProdottoDisclaimer_root__ObOrk","rotation":"ProdottoDisclaimer_rotation__RQSpp","preventivoBoxBubble":"ProdottoDisclaimer_preventivoBoxBubble__KdjsF"};